import { useEffect } from 'react';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { Store } from 'src/store';
import { setSkipTomorrowDefaultDate, userLogin, userLogout } from '../actions';
import { editableOrderCartSlice } from '../cart';

interface UseSyncUserStateWithCartProps {
  store: Store;
}

export function useSyncUserStateWithCart({ store }: UseSyncUserStateWithCartProps) {
  const [currentUser, currentUserLoading] = useCurrentUser();
  const isLoggedIn = Boolean(currentUser?.id);
  const cartLoggedIn = store.getState().cart.userLoggedIn;
  const editableOrderCartLoggedIn = store.getState().editableOrderCart.userLoggedIn;

  const skipTomorrowDefaultDate = (currentUser?.orderCount ?? 0) > 0;
  const isSkipTomorrowDefaultDate = store.getState().cart.skipTomorrowDefaultDate;

  // Sync main cart userLoggedIn state
  useEffect(() => {
    if (isLoggedIn !== cartLoggedIn && !currentUserLoading) {
      store.dispatch(isLoggedIn ? userLogin() : userLogout());
    }
  }, [isLoggedIn, cartLoggedIn, currentUserLoading, store]);

  // Sync editableOrderCart userLoggedIn state
  useEffect(() => {
    if (isLoggedIn !== editableOrderCartLoggedIn && !currentUserLoading) {
      store.dispatch(
        isLoggedIn ? editableOrderCartSlice.actions.userLogin() : editableOrderCartSlice.actions.userLogout()
      );
    }
  }, [isLoggedIn, editableOrderCartLoggedIn, currentUserLoading, store]);

  useEffect(() => {
    if (skipTomorrowDefaultDate !== isSkipTomorrowDefaultDate && !currentUserLoading) {
      store.dispatch(setSkipTomorrowDefaultDate({ skipTomorrowDefaultDate }));
    }
  }, [skipTomorrowDefaultDate, isSkipTomorrowDefaultDate, currentUserLoading, store]);
}
